import { create } from "zustand"

// Which quotation's on-demand result CSV is being generated right now (REQ-420), or null.
//
// Module-level rather than per-hook state on purpose: the control exists on two surfaces at once —
// the quotations table row menu and the editor's burger menu, which sits in the Apryse shadow DOM
// behind the drawer. Per-instance state would let those two start concurrent generations, and would
// lose the busy flag whenever Apryse re-roots the header. One store makes "one generation at a time"
// actually global and survives the re-root.
type ResultCsvStore = {
	busyQuotationId: number | null
	setBusyQuotationId: (quotationId: number | null) => void
}

export const useResultCsvStore = create<ResultCsvStore>((set) => ({
	busyQuotationId: null,
	setBusyQuotationId: (quotationId) => set({ busyQuotationId: quotationId }),
}))

// Selector hooks, so a component subscribes only to the slice it renders — the orchestrator takes
// the download action WITHOUT either of these and therefore never re-renders on a CSV download.
export const useResultCsvBusyQuotationId = () => useResultCsvStore((state) => state.busyQuotationId)

export const useIsResultCsvPending = () => useResultCsvStore((state) => state.busyQuotationId !== null)
